// extracted by mini-css-extract-plugin
export default {"root":"styles_root__E2zKD","tags":"styles_tags__VlEe7"};